// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '../../../../../../../common/atoms/BodyCopy';
import withStyles from '../../../../../../../common/hoc/withStyles';
import styles from '../../styles/RewardsPointsStatusBar.style';
import Anchor from '../../../../../../../common/atoms/Anchor';
import internalEndpoints from '../../../../internalEndpoints';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCurrency,
  lblRewardPoints,
} from '../../../../../../../../utils/labels/globalGeneric.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, {
  CHECKOUT_LABELS,
  GLOBAL_LABELS,
} from '../../../../labels/AccountCommon.labels';

const RewardsPointsStatusBar = ({
  className,
  pointsToNextReward,
  currentPoints,
  totalRewards,
  useRouterNavigation,
}) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, AccountCommonLabels);
  return (
    <div className={className}>
      <BodyCopy component="div" className="table-container">
        <BodyCopy component="div" className="table-item rewards-point">
          <BodyCopy textAlign="left" fontSize="fs18" fontWeight="bold" fontFamily="secondary">
            {currentPoints}
          </BodyCopy>
          <BodyCopy fontSize="fs14" textAlign="left" fontFamily="secondary">
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_GENERIC_LABELS}.${lblRewardPoints}`,
                GlobalGenericLabels
              ),
              'lbl_reward_points'
            )}
          </BodyCopy>
        </BodyCopy>
        <BodyCopy component="div" className="table-item to-next-reward">
          <BodyCopy textAlign="left" fontSize="fs18" fontWeight="bold" fontFamily="secondary">
            {pointsToNextReward}
          </BodyCopy>
          <BodyCopy fontSize="fs14" textAlign="left" fontFamily="secondary">
            {renderLabel(
              globalLabels?.accountDrawer?.lbl_rewardPointStatusBar_toNextAward,
              'lbl_rewardPointStatusBar_toNextAward'
            )}
          </BodyCopy>
        </BodyCopy>
        <BodyCopy component="div" className="table-item my-rewards-item">
          <BodyCopy fontSize="fs18" fontWeight="bold" fontFamily="secondary" textAlign="left">
            <sup className="rewards-dollar-symbol">
              {getLabelFromCopyOrFromTranslation(
                `${GLOBAL_GENERIC_LABELS}.${lblCurrency}`,
                GlobalGenericLabels
              )}
            </sup>
            {totalRewards && Math.trunc(totalRewards)}
          </BodyCopy>
          <BodyCopy
            fontSize="fs14"
            textAlign="left"
            fontFamily="secondary"
            className="capFirstLetter"
          >
            {renderLabel(
              checkoutLabels?.bagPage?.lbl_couponlist_rewards,
              'lbl_couponlist_rewards'
            ).toLowerCase()}
          </BodyCopy>
        </BodyCopy>
      </BodyCopy>
      <BodyCopy component="div" className="rewards-status-progress-wrapper">
        <BodyCopy component="div" className="rewards-status-progress" />
      </BodyCopy>
      <BodyCopy className="view-my-rewards-wrapper">
        <Anchor
          className="view-my-rewards"
          to={internalEndpoints.placeRewardsPage.link}
          asPath={internalEndpoints.placeRewardsPage.path}
          fontSizeVariation="large"
          useRouterNavigation={useRouterNavigation}
        >
          {renderLabel(
            globalLabels?.accountDrawer?.lbl_rewardPointStatusBar_viewMyRewards,
            'lbl_rewardPointStatusBar_viewMyRewards'
          )}
        </Anchor>
      </BodyCopy>
    </div>
  );
};

RewardsPointsStatusBar.propTypes = {
  className: PropTypes.string,
  pointsToNextReward: PropTypes.string,
  currentPoints: PropTypes.string,
  totalRewards: PropTypes.string,
  useRouterNavigation: PropTypes.bool,
};

RewardsPointsStatusBar.defaultProps = {
  className: '',
  pointsToNextReward: '',
  currentPoints: '',
  totalRewards: '',
  useRouterNavigation: false,
};

export default withStyles(RewardsPointsStatusBar, styles);
export { RewardsPointsStatusBar as RewardsPointsStatusBarVanilla };
